import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { set, useForm } from "react-hook-form";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"
const Option = (props) => {
  return (
      <div>
          {
              //console.log("results=="+JSON.stringify(props))
          }
          <components.Option {...props}>
              <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
              />{" "}
              <label>{props.label}</label>
          </components.Option>
      </div>
  );
};

const StudentReport: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 50; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [jobfilterlist, setJobFilterList] = useState([]);
      const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducation] = useState([]);
  const [categories, setCategory] = useState([]);
  const [currentYearList, setCurrentYearList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [mulcategories_d, setMulCategory_d] = useState([]);
  const [industryRequestArray_d, setIndustryRequestArrayd] = useState([]);
  const [optionCatSelected_d, setoptionCatSelectedd] = useState(null);
  const [mulyears_d, setMulYear_d] = useState([]);
  const [yearRequestArray_d, setYearRequestArrayd] = useState([]);
  const [optionYearSelected_d, setoptionYearSelectedd] = useState(null);
  const [mulschool_d, setMulSchool_d] = useState([]);
  const [schoolRequestArray_d, setSchoolRequestArrayd] = useState([]);
  const [optionSchoolSelected_d, setoptionSchoolSelectedd] = useState(null);
  const [muljobTypes, setMulJobTypes] = useState([]);
  const [optionSelected_d, setoptionSelectedd] = useState(null);
  const [jobtypeRequestArray_d, setJobTypeRequestArrayd] = useState([]);
  const [muleducation, setMulEducationTypes] = useState([]);
  const [educationRequestArray_d, setEducationRequestArrayd] = useState([]);
  const [optionEducationSelected_d, setoptionEducationSelectedd] = useState(null);
  const [reportSchoolDistrict, setReportSchoolDistrict] = useState('');
  const [reportCurrentlyPursuig, setReportCurrentlyPursuig] = useState('');
  const [reportGraduatingYear, setReportGraduatingYear] = useState('');
  const [reportJobtype, setReportJobtype] = useState('');
  const [reportFieldofInterest, setReportFieldofInterest] = useState('');
  const [runReport, setRunReport] = useState<any>(0);

  var FileSaver = require('file-saver');

  var industry_webvar = [];
  var year_webvar = [];
  var school_webvar = [];
  var jobtype_webvar = [];
  var education_webvar = [];

      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all", mode: "onBlur"
      });

      const getCurrentYear = () =>{
        var currentYear = new Date().getFullYear()
        var years = [];
        years.push(currentYear);
        for(var i=1;i<7;i++){
          years.push(currentYear+i);
        }
        setCurrentYearList(years);
        var dummArray = [];
          for (var i = 0; i < years.length; i++) {
              dummArray.push({ "label": years[i], "value": years[i] })
          }
          setMulYear_d(dummArray)
      }

      const getSchoolList = () => {
        const requestObject = {
          "siteId": 2,
          "pageNumber": 1,
          "pageSize": 150
        }

        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            //'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        services.getSchoolnDatapag(requestOptions).then((res) => {
          if (res) {
            setSchoolList(res);
            }
            var dummArray = [];
            for (var i = 0; i < res.length; i++) {
                dummArray.push({ "label": res[i].name, "value": res[i].schoolId })
            }
            setMulSchool_d(dummArray)
        });

   }

   const handleChange_d = (selected) => {
    var dummArray = [];
    var dummArray_label = '';
    console.log(selected);
    for (var i = 0; i < selected.length; i++) {
        dummArray.push(selected[i].value.toString());
        if(i==0){
          dummArray_label = selected[i].label.toString();
        }
        else{
          dummArray_label = dummArray_label+', '+selected[i].label.toString();
        }
        jobtype_webvar.push(selected[i].value.toString());
    }
    console.log(dummArray);
    setoptionSelectedd(selected);
    //jobtype_webvar = dummArray;
    $('#jobtype_selected').val(JSON.stringify(dummArray));
    $('#jobtype_selfilter').val(dummArray_label);
    setJobTypeRequestArrayd(dummArray);
    setReportJobtype(dummArray_label);
};

      useEffect(() =>
      {
        getIndustryData();
        getCurrentYear();
        getSchoolList();
        $(".load-wrap").hide();
        services.getLocationCounty().then((res) => {
          console.log("getLocationCounty data=" + JSON.stringify(res.data));
          setLocationCounty(res.data.content);
        });
        services.getJobType().then((res) => {
        /* console.log("setJobType data=" + JSON.stringify(res.data));
          setJobType(res.data.content); */

          var jobtype_unsort = res.data.content;
          jobtype_unsort = jobtype_unsort.filter(function (elem) {
            return elem.name !== 'Continuing Education';
          });
          var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
          array_move(jobtypes_sorted, 0, (jobtypes_sorted.length-1));
          setJobType(jobtypes_sorted);
          var dummArray = [];
            for (var i = 0; i < jobtypes_sorted.length; i++) {
                dummArray.push({ "label": jobtypes_sorted[i].name, "value": jobtypes_sorted[i].jobTypeId })
            }
            setMulJobTypes(dummArray)

        });
        services.getEducation().then((res) => {
          console.log("getEducation data=" + JSON.stringify(res.data));
          setEducation(res.data.content);
          var dummArray = [];
          var serviceresponse = res.data.content;
          serviceresponse = serviceresponse.filter(function (elem) {
            return elem.name != 'PhD';
          });
          
          for (var i = 0; i < serviceresponse.length; i++) {
              dummArray.push({ "label": serviceresponse[i].name, "value": serviceresponse[i].educationId })
          }
          setMulEducationTypes(dummArray)
        });
       // getjobslist(ITEMS_PER_PAGE,'1');

      },[]);

      const handleChangeForEdu_d = (selected) => {

        var dummArray = [];
        var dummArray_label = '';
        for (var i = 0; i < selected.length; i++) {
            //alert(selected[i].label.toString());
            dummArray.push(selected[i].value.toString());
            if(i==0){
              dummArray_label = selected[i].label.toString();
            }
            else{
              dummArray_label = dummArray_label+', '+selected[i].label.toString();
            }
            education_webvar.push(selected[i].value.toString());
        }
        setEducationRequestArrayd(dummArray);
        //industry_webvar = dummArray;
        $('#education_selected').val(JSON.stringify(dummArray));
        $('#education_selfilter').val(dummArray_label);
        setoptionEducationSelectedd(selected);
        setReportCurrentlyPursuig(dummArray_label);
  };

      function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

    const handleChangeForCate_d = (selected) => {
      //alert();
      var dummArray = [];
      var dummArray_label = '';
      for (var i = 0; i < selected.length; i++) {
          //alert(selected[i].label.toString());
          dummArray.push(selected[i].value.toString());
          if(i==0){
            dummArray_label = selected[i].label.toString();
          } else{
            dummArray_label = dummArray_label+', '+selected[i].label.toString();
          }
          industry_webvar.push(selected[i].value.toString());
      }
      setIndustryRequestArrayd(dummArray);
      //industry_webvar = dummArray;
      $('#industry_selected').val(JSON.stringify(dummArray));
      $('#industry_selfilter').val(dummArray_label);
      setoptionCatSelectedd(selected);
      setReportFieldofInterest(dummArray_label);
  };

  const handleChangeForYear_d = (selected) => {
    //alert();
    var dummArray = [];
    var dummArray_label = '';
    for (var i = 0; i < selected.length; i++) {
        //alert(selected[i].label.toString());
        dummArray.push(selected[i].value.toString());
        if(i==0){
          dummArray_label = selected[i].label.toString();
        } else{
          dummArray_label = dummArray_label+', '+selected[i].label.toString();
        }
        year_webvar.push(selected[i].value.toString());
    }
    setYearRequestArrayd(dummArray);
    //industry_webvar = dummArray;
    $('#year_selected').val(JSON.stringify(dummArray));
    $('#year_selfilter').val(dummArray_label);
    setoptionYearSelectedd(selected);
    setReportGraduatingYear(dummArray_label);
};

const handleChangeForSchool_d = (selected) => {
  //alert();
  var dummArray = [];
  var dummArray_label = '';
  for (var i = 0; i < selected.length; i++) {
      //alert(selected[i].label.toString());
      dummArray.push(selected[i].value.toString());
      if(i==0){
        dummArray_label = selected[i].label.toString();
      } else{
        dummArray_label = dummArray_label+', '+selected[i].label.toString();
      }
      school_webvar.push(selected[i].value.toString());
  }
  setSchoolRequestArrayd(dummArray);
  //industry_webvar = dummArray;
  $('#school_selected').val(JSON.stringify(dummArray));
  $('#school_selfilter').val(dummArray_label);
  setoptionSchoolSelectedd(selected);
  setReportSchoolDistrict(dummArray_label);
};
      const getIndustryData = () => {
        services.getIndustryData().then((res) => {
          setCategory(res.data.content);
          var dummArray = [];
          for (var i = 0; i < res.data.content.length; i++) {
              dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
          }
          setMulCategory_d(dummArray)
        });
      }
      const submitValue = () => {
        getjobslist(ITEMS_PER_PAGE,'1');
      }
      const searchList = () => {
       getjobslist(ITEMS_PER_PAGE,'1');
      }

      const handlePageChange2 = (offset,triggerevent) => {
        getjobslist(ITEMS_PER_PAGE,offset);
      };

      function validateCheck() {

      }

      const filterContent_full = () => {

        var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            var industries_filter = JSON.parse(selected_ind);
        }

        var year_filter:any = [];
        var selected_yr:any = $('#year_selected').val();
        if (selected_yr != '') {
            var year_filter = JSON.parse(selected_yr);
        }

        var school_filter:any= [];
        var selected_school:any = $('#school_selected').val();
        if (selected_school != '') {
            var school_filter = JSON.parse(selected_school);
        }

        var jobtypes_filter:any = [];
        var selected_types:any = $('#jobtype_selected').val();
        if (selected_types != '') {
            var jobtypes_filter = JSON.parse(selected_types);
        }

        var educations_filter:any = [];
        var selected_edu:any = $('#education_selected').val();
        if (selected_edu != '') {
            var educations_filter = JSON.parse(selected_edu);
        }

      
        //setReportSchoolDistrict($('#school_selfilter').val());
        //setReportCurrentlyPursuig($('#education_selfilter').val());
        //setReportGraduatingYear($('#year_selfilter').val());
        //setReportJobtype($('#jobtype_selfilter').val());
        //setReportFieldofInterest($('#industry_selfilter').val());
        console.log($('#industry_selfilter').val());
      

        const requestObject = {
          "siteId": "2",
          "categoriesOfExpertise": industries_filter,
          "classYear": year_filter,
          "schoolId": school_filter,
          "titleSummary": $('#job_title').val(),
          "pageNumber": 1,
          "levelOfEducation":educations_filter,
          "jobType":jobtypes_filter,
          "pageSize": 50000,
          "sortBy": "updatedOn"
      }
        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };

        $(".load-wrap").show();
        services.getStudentReportList(requestOptions).then((res) => {
          //console.log(JSON.stringify(res.content))
          if (res) {

                var contAr = res.content;

                //setJobFilterList(res.content);
                  download_excel(contAr);
           }

        });

    }

    function download_excel(profileListFull:any){
      //console.log(profileListFull);

      var today = new Date();
      var month = today.toLocaleString('en-US', {month: 'short'});
      var date= today.getDate();
      var year = today.getFullYear();

      var filename = "Student-export-"+month+"-"+date+"-"+year+".csv";
     // console.log(filename);
      let csv = '';
      let row = '';
      let headers = '';


      var row2 = '';
      if (reportSchoolDistrict != '') 
            row2 = row2+'School District : '+reportSchoolDistrict.replace(/,/g, ";");

      if(reportSchoolDistrict != '' && reportCurrentlyPursuig != '')
            row2 = row2+';      ';

      if (reportCurrentlyPursuig != '') 
            row2 = row2+'Currently Pursuing : '+reportCurrentlyPursuig.replace(/,/g, ";");

      if(reportCurrentlyPursuig != '' && reportGraduatingYear != '')
            row2 = row2+';      ';      

      if (reportGraduatingYear != '') 
            row2 = row2+'Graduating Year : '+reportGraduatingYear.replace(/,/g, ";");

      if(reportGraduatingYear != '' && reportJobtype != '')
            row2 = row2+';      '; 

      if (reportJobtype != '') 
            row2 = row2+'Job Types Interested In : '+reportJobtype.replace(/,/g, ";");

      if(reportJobtype != '' && reportFieldofInterest != '')
            row2 = row2+';      '; 

      if (reportFieldofInterest != '') 
            row2 = row2+'Fields of Interest : '+reportFieldofInterest.replace(/,/g, ";");

console.log(reportFieldofInterest);

      var jobtypeslisthead = 'Students Report'+',';
      var jobtypeslisthead = jobtypeslisthead+'\n'+row2+',';
     var jobtypeslisthead = jobtypeslisthead+'\n'+'Name'+','+'Email'+','+'Phone'+','+'Education'+','+'Class Year'+','+'School District'+',';

      headers = headers.concat(jobtypeslisthead);

      csv = csv.concat(headers);
      row = '';

      //alert(profileListFull.length);
      for(var i=0; i<profileListFull.length; i++){

              var jobtypeslistrow = "";
              var cats = profileListFull[i].categoryName;
              var selectedcategs = cats.join('; ');
              selectedcategs = selectedcategs.replace(/,/g, ";");

              var jobtypes = profileListFull[i].jobTypeName;
              var selectedjobtypes = jobtypes.join('; ');
              selectedjobtypes = selectedjobtypes.replace(/,/g, ";");

              if(profileListFull[i].schoolName == null || profileListFull[i].schoolName == ''){
                var school = '--';
              }
              else {
                var school:string = profileListFull[i].schoolName;
              }

              if(profileListFull[i].educationName == null || profileListFull[i].educationName == ''){
                var education = '--';
              }
              else {
                var education:string = profileListFull[i].educationName;
              }

              if(profileListFull[i].phoneno == '0000000000' || profileListFull[i].phoneno == '0'){
                var phone = '000-000-0000';
              }
              else {
                var phone:string = profileListFull[i].phoneno;
              }
              var firstname  = profileListFull[i].firstName;
              var fname = firstname.replace(/,/g, ";");

              var lastname  = profileListFull[i].lastName;
              var lname = lastname.replace(/,/g, ";");

              var emailid  = profileListFull[i].email;
              var email = emailid.replace(/,/g, ";");


              if(profileListFull[i].classYear == null || profileListFull[i].classYear == ''){
                var classyear = '--';
              }
              else {
                var classyear:string = profileListFull[i].classYear;
              }

             jobtypeslistrow = "\n"+fname+" "+lname+','+email+','+phone+','+education+','+classyear+','+school+',';


          row = row.concat(jobtypeslistrow);

      }
      csv = csv.concat(row);

      var file = new File([csv], filename, {type: "application/csv"});
      FileSaver.saveAs(file);
      $(".load-wrap").hide();
    }


      const getjobslist = (ITEMS_PER_PAGE,pageNumber) => {

        var industries_filter:any = [];
        var selected_ind:any = $('#industry_selected').val();
        if (selected_ind != '') {
            var industries_filter = JSON.parse(selected_ind);
        }

        var year_filter:any = [];
        var selected_yr:any = $('#year_selected').val();
        if (selected_yr != '') {
            var year_filter = JSON.parse(selected_yr);
        }

        var school_filter:any = [];
        var selected_school:any = $('#school_selected').val();
        if (selected_school != '') {
            var school_filter = JSON.parse(selected_school);
        }

        var jobtypes_filter:any = [];
        var selected_types:any = $('#jobtype_selected').val();
        if (selected_types != '') {
            var jobtypes_filter = JSON.parse(selected_types);
        }

        var educations_filter:any = [];
        var selected_edu:any = $('#education_selected').val();
        if (selected_edu != '') {
            var educations_filter = JSON.parse(selected_edu);
        }


  //setReportSchoolDistrict($('#school_selfilter').val());
  //setReportCurrentlyPursuig($('#education_selfilter').val());
  //setReportGraduatingYear($('#year_selfilter').val());
  //setReportJobtype($('#jobtype_selfilter').val());
  //setReportFieldofInterest($('#industry_selfilter').val());
  setRunReport(1);

        const requestObject = {
          "siteId": "2",
          "categoriesOfExpertise": industries_filter,
          "classYear": year_filter,
          "schoolId": school_filter,
          "titleSummary": $('#job_title').val(),
          "pageNumber": pageNumber,
          "levelOfEducation":educations_filter,
          "jobType":jobtypes_filter,
          "pageSize": ITEMS_PER_PAGE,
          "sortBy": "updatedOn"
      }
        // console.log(JSON.stringify(objInputAvailableJobs));
        var accessTokenIn = sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
          },
          body: JSON.stringify(requestObject)
        };
        $(".load-wrap").show();
        services.getStudentReportList(requestOptions).then((res) => {
          console.log(JSON.stringify(res.content))
          if (res) {
             //console.log(res.data);
               // $(".paginationContent").show();
                setTotalItems(res.totalElements);
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);

                var contAr = res.content;
                //setProfileList(res.content);
                if(res){
                  setJobFilterList(res.content);
                }
                $(".load-wrap").hide();
           }

        });
}

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Students Report'})}</PageTitle>


        <div>

      {/* begin::Body */}
      <div>
        {/* begin::Table container */}
        <div className='table-responsive ofx-hidden'>


        <form onSubmit={handleSubmit(submitValue)}>
        <div>
          <div className="row">
          <div className="col-lg-12 d-none">
              <div className="mb-10">
              <div className="d-flex justify-content-end">
                    <button type="button" onClick={filterContent_full} className="btn btn-primary ml-2 mb-0" style={{ maxWidth: "200px" }}>Export to Excel</button>
                  </div>
              </div>
            </div>

            <div className="col-lg-12 d-none">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Keyword Search</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder="Search by Name/ Email"  />
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">School District</label>

                </div>
                <input type="hidden" id="school_selected" />
                <input type="hidden" id="school_selfilter" />
                <ReactSelect
                     // className="form-select"
                      options={mulschool_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForSchool_d}
                      //allowSelectAll={false}
                      value={optionSchoolSelected_d}
                      defaultValue={['1']}
                  />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Currently Pursuing</label>

                </div>
                <input type="hidden" id="education_selected" />
                <input type="hidden" id="education_selfilter" />
                <ReactSelect
                       // className="form-select"
                        options={muleducation}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChangeForEdu_d}
                        //allowSelectAll={true}
                        value={optionEducationSelected_d}
                    />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Graduating Year</label>

                </div>
                <input type="hidden" id="year_selected" />
                <input type="hidden" id="year_selfilter" />
                <ReactSelect
                     // className="form-select"
                      options={mulyears_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForYear_d}
                      //allowSelectAll={false}
                      value={optionYearSelected_d}
                      defaultValue={['1']}
                  />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Job Types Interested in</label>

                </div>
                <ReactSelect
                       // className="form-select"
                        options={muljobTypes}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                            Option
                        }}
                        onChange={handleChange_d}
                        //allowSelectAll={true}
                        value={optionSelected_d}
                    />
                    <input type="hidden" id="jobtype_selected" />
                    <input type="hidden" id="jobtype_selfilter" />

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Fields of Interest</label>

                </div>
                <input type="hidden" id="industry_selected" />
                <input type="hidden" id="industry_selfilter" />
                <ReactSelect
                     // className="form-select"
                      options={mulcategories_d}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                          Option
                      }}
                      onChange={handleChangeForCate_d}
                     // allowSelectAll={false}
                      value={optionCatSelected_d}
                      defaultValue={['1']}
                  />

              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                <div className="d-block">
                    <button type="submit" className="btn btn-primary ml-2 mb-10" style={{ maxWidth: "200px" }}>Run Report</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>
          {/* begin::Table */}
          <div className="card">
          <div className="card-body px-2 pt-0">
              <div className="d-flex justify-content-end text-right">
           <div className={runReport == 1 ? "tag-wrp" : "tag-wrp d-none"}>
                <div className={reportSchoolDistrict != '' ? "tag-inn" : ''}><label>{reportSchoolDistrict != '' ? 'School District : ' : '' }</label>{reportSchoolDistrict != '' ? reportSchoolDistrict : '' }</div>

                <div className={reportCurrentlyPursuig != '' ? "tag-inn" : ''}><label>{reportCurrentlyPursuig != '' ? 'Currently Pursuing : ' : '' }</label>{reportCurrentlyPursuig != '' ? reportCurrentlyPursuig : '' }</div>

                <div className={reportGraduatingYear != '' ? "tag-inn" : ''}><label>{reportGraduatingYear != '' ? 'Graduating Year : ' : '' }</label>{reportGraduatingYear != '' ? reportGraduatingYear : '' }</div>

                <div className={reportJobtype != '' ? "tag-inn" : ''}><label>{reportJobtype != '' ? 'Job Types Interested In : ' : '' }</label>{reportJobtype != '' ? reportJobtype : '' }</div>

                <div className={reportFieldofInterest != '' ? "tag-inn" : ''}><label>{reportFieldofInterest != '' ? 'Fields Of Interest : ' : '' }</label>{reportFieldofInterest != '' ? reportFieldofInterest : '' }</div>
            </div>
           <button type="button" onClick={filterContent_full} className="btn btn-primary my-2 align-self-center" style={{ minWidth: "160px", marginLeft:"auto" }}> Export to Excel</button>
           </div>
              {/* <div className="new-scrl-tbl">
                <div className="dummy"></div>
              </div> */}
           <div className="new-scrl-tbl2">
              <div>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 wid'>
            {/* begin::Table head */}
            <thead>
            {/* <tr>
                <td colSpan={'6'}>
                {reportSchoolDistrict != '' ? 'School District : '+reportSchoolDistrict : ''}
                {reportCurrentlyPursuig != '' ? ', Currently Pursuing : '+reportCurrentlyPursuig : '' }
                {reportGraduatingYear != '' ? ', Graduating Year : '+reportGraduatingYear : '' }
                {reportJobtype != '' ? ', Job Types Interested In : '+reportJobtype : '' }
                {reportFieldofInterest != '' ? ', Fields Of Interest : '+reportFieldofInterest : '' }

                </td>
              </tr> */}

               <tr className='fw-bolder text-muted report-tbl'>
                 <th>Name</th>
                 <th>Email</th>
                <th>Phone</th>
                <th>Education</th>
                <th>Class Year</th>
                <th>School District</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {
	          jobfilterlist.map((data, index) => (
              <tr className="fw-bolder">

                <td style={{width:"150px", maxWidth:"150px", verticalAlign:"baseline"}}>{data.firstName+' '+data.lastName}</td>
                <td style={{width:"180px", maxWidth:"180px", verticalAlign:"baseline"}}>{data.email}</td>
                <td style={{width:"100px", maxWidth:"130px",verticalAlign:"baseline"}}>{data.phoneno}</td>
                <td style={{width:"130px", maxWidth:"100px",verticalAlign:"baseline"}}>{(data.educationName == null || data.educationName == '') ? '--' : data.educationName}</td>
                <td style={{width:"70px", maxWidth:"100px", verticalAlign:"baseline"}}>{data.classYear}</td>
                <td style={{width:"100px", maxWidth:"100px", verticalAlign:"baseline"}}>{(data.schoolName == null || data.schoolName == '') ? '--' : data.schoolName}</td>
              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table></div></div>

          <span className="mb-2 d-block"></span>

          <Pagination

                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
                </div></div>

          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      <section className="load-wrap">
          <div className="loadingIcon">
            <img src="/media/icons/duotune/general/loading.gif" className="m-auto"></img>
            <span>Loading... <br /> please be patient..</span>
             </div>
        </section>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {StudentReport}